import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { showAlert, hideAlert } from '../actions/alert';

const state = {
  errorMessage: '',
  alertIsOpened: false,
};

const alert = handleActions(
  {
    [showAlert]: (state, action) => {
      const { error } = action;
      const { data } = action.payload.response;
      return {
        ...state,
        errorMessage: data.message || '',
        alertIsOpened: error,
      };
    },
    [hideAlert]: (state, action) => {
      return { ...state, errorMessage: '', alertIsOpened: false };
    },
  },
  state
);
const Alert = combineReducers({
  alert,
});
export { Alert };
